const feedsTypes = {

  index: {
    request: "FEEDS_INDEX_REQUEST",
    success: "FEEDS_INDEX_SUCCESS",
    failure: "FEEDS_INDEX_FAILURE"
  },

  create: {
    request: "CREATE_FEED_REQUEST",
    success: "CREATE_FEED_SUCCESS",
    failure: "CREATE_FEED_FAILURE",
    after_redirect: "CREATE_FEED_AFTER_REDIRECT"
  },

  publish: {
    request: "PUBLISH_FEED_REQUEST",
    success: "PUBLISH_FEED_SUCCESS",
    success_minimal: "PUBLISH_FEED_SUCCESS_MINIMAL",
    failure: "PUBLISH_FEED_FAILURE",
  },

  update_xml: {
    request: "UPDATE_XML_REQUEST",
    success: "UPDATE_XML_SUCCESS",
    success_minimal: "UPDATE_XML_SUCCESS_MINIMAL",
    failure: "UPDATE_XML_FAILURE",
  },

  unpublish: {
    request: "UNPUBLISH_FEED_REQUEST",
    success: "UNPUBLISH_FEED_SUCCESS",
    success_minimal: "UNPUBLISH_FEED_SUCCESS_MINIMAL",
    failure: "UNPUBLISH_FEED_FAILURE",
  },

  publish_all: {
    request: "PUBLISH_ALL_REQUEST",
    success: "PUBLISH_ALL_SUCCESS",
    failure: "PUBLISH_ALL_FAILURE",
  },

  unpublish_all: {
    request: "UNPUBLISH_ALL_REQUEST",
    success: "UNPUBLISH_ALL_SUCCESS",
    failure: "UNPUBLISH_ALL_FAILURE",
  },

  get: {
    request: "GET_PROJECT_REQUEST",
    success: "GET_PROJECT_SUCCESS",
    failure: "GET_PROJECT_FAILURE",
    success_minimal: "GET_PROJECT_SUCCESS_MINIMAL",
    refresh_request: "GET_PROJECT_REFRESH_REQUEST",
    reset_redirect: "RESET_FEED_REDIRECT"
  },

  create_optimized: {
    request: "CREATE_OPTIMIZED_FEED_REQUEST",
    success: "CREATE_OPTIMIZED_FEED_SUCCESS",
    failure: "CREATE_OPTIMIZED_FEED_FAILURE"
  },

  archive: {
    request: "ARCHIVE_FEED_REQUEST",
    success: "ARCHIVE_FEED_SUCCESS",
    failure: "ARCHIVE_FEED_FAILURE"
  },

  project_archive: {
    request: "PROJECT_ARCHIVE_FEED_REQUEST",
    success: "PROJECT_ARCHIVE_FEED_SUCCESS",
    failure: "PROJECT_ARCHIVE_FEED_FAILURE"
  },

  restore: {
    request: "RESTORE_FEED_REQUEST",
    success: "RESTORE_FEED_SUCCESS",
    success_minimal: "RESTORE_FEED_SUCCESS_MINIMAL",
    failure: "RESTORE_FEED_FAILURE"
  },

  destroy: {
    request: "DESTROY_FEED_REQUEST",
    success: "DESTROY_FEED_SUCCESS",
    failure: "DESTROY_FEED_FAILURE"
  },

  reset_errors: "RESET_FEED_ERRORS"

}

export default feedsTypes



// WEBPACK FOOTER //
// ./src/js/constants/feedsTypes.js